// specifically for ActionButton labels
export const buttonText = {
  save: 'Simpan',
  addAccount: 'Tambah akun',
  addTD: 'Buka Deposito',
  apply: 'Ajukan',
  applyNow: 'Ajukan Sekarang',
  confirm: 'Konfirmasi',
  continue: 'Lanjutkan',
  login: 'Masuk',
  loginFc: 'Login',
  yes: 'Ya',
  no: 'Tidak',
  notMe: 'Bukan saya',
  forgotLogin: 'Lupa login',
  donateNow: 'Donasi sekarang',
  makePlacement: 'Buat penempatan',
  pay: 'Bayar',
  registerNow: 'Daftar sekarang',
  transfer: 'Transfer',
  skip: 'Lewati',
  viewStatement: 'Lihat pernyataan',
  requestTac: 'Minta TAC',
  downloadReceipt: 'Download Resi',
  done: 'Selesai',
  ok: 'OK',
  cancel: 'Batal',
  addFavourite: 'Tambah Favorit',
  newTransfer: 'Transfer Baru',
  search: 'Cari',
  back: 'Kembali',
  next: 'Lanjut',
  nextFc: 'Lanjutkan',
  edit: 'Ubah',
  delete: 'Hapus',
  update: 'Perbarui',
  seeTutorial: 'Lihat Tutorial',
  newPayment: 'Pembayaran Baru',
  newPurchase: 'Pembelian Baru',
  viewSimulation: 'Lihat Simulasi',
  createGoal: 'Buat Tujuan di M2U',
  showMore: 'Tampil lagi',
  showLess: 'Tampil sedikit',
  simulateGoal: 'Mulai Simulasi',
  simulateFinancialGoal: 'Simulasikan Rencana Keuangan Anda',
  clickHere: 'Klik disini',
  letsGo: 'Ayo Mulai',
  close: 'Tutup',
  addCurrency: 'Tambah Mata Uang',
  remove: 'Hapus',
  compose: 'Kirim',
  reply: 'Balas',
  addDeposit: 'Tambah Deposito',
  register: 'Daftar',
  confirmationSecure2u: 'Konfirmasi',
};
